export default __webpack_public_path__ + "static/media/razer-bg-2x.bce3f000.jpg";